import GetPaymentMethodsQuery from './GetPaymentMethodsQuery';

export default GetPaymentMethodsQuery;
